module.exports = __webpack_public_path__ + "img/animatedLoader.acd491eb.gif";